import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

const ROWS = 6

const DocumentBrowserSkeleton: React.FC = () => {
  return (
    <div>
      <div className="flex items-center gap-2 mb-2 flex-wrap">
        <Skeleton className="h-8 w-28 rounded-md" />
        <Skeleton className="h-8 w-20 rounded-md" />
        <div className="flex-1" />
        <Skeleton className="h-8 w-[72px] rounded-md" />
        <Skeleton className="h-8 w-[220px] rounded-md" />
      </div>

      <div className="rounded-md border border-border overflow-hidden bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="!w-9 !p-0" />
              <TableHead style={{ width: '50%' }}><Skeleton className="h-3 w-16" /></TableHead>
              <TableHead style={{ width: '15%' }}><Skeleton className="h-3 w-20" /></TableHead>
              <TableHead style={{ width: '20%' }}><Skeleton className="h-3 w-16" /></TableHead>
              <TableHead style={{ width: '10%' }}><Skeleton className="h-3 w-10" /></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: ROWS }).map((_, i) => (
              <TableRow key={i}>
                <TableCell className="!w-9 !p-0 text-center">
                  <Skeleton className="h-4 w-4 mx-auto" />
                </TableCell>
                <TableCell>
                  <div className="flex items-center gap-2">
                    <Skeleton className="h-4 w-4 shrink-0" />
                    <Skeleton className={`h-4 ${i % 3 === 0 ? 'w-32' : i % 3 === 1 ? 'w-48' : 'w-40'}`} />
                  </div>
                </TableCell>
                <TableCell><Skeleton className="h-4 w-20" /></TableCell>
                <TableCell><Skeleton className="h-4 w-24" /></TableCell>
                <TableCell><Skeleton className="h-4 w-12" /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <div className="flex items-center justify-end py-2 px-1">
        <Skeleton className="h-3 w-16" />
      </div>
    </div>
  )
}

export default DocumentBrowserSkeleton
